import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
    getLabelsByProject,
    createLabel,
    findLabelByValue,
    getLabelsForTestCase,
    assignLabelToTestCase,
    removeLabelFromTestCase,
} from '../services/label.service';

import { labelKeys } from '../constants/labelKeys';

export const useLabelsByProject = (projectId) => {
    return useQuery({
        queryKey: [labelKeys.projectLabels, projectId],
        queryFn: () => getLabelsByProject(projectId),
        enabled: !!projectId,
    });
};

export const useCreateLabel = ({ onSuccess, onError } = {}) => {
    return useMutation({
        mutationFn: createLabel,
        onSuccess: (data) => onSuccess?.(data),
        onError: (error) => onError?.(error),
    });
};

export const useFindLabelByValue = (projectId, value) => {
    return useQuery({
        queryKey: [labelKeys.searchLabel, projectId, value],
        queryFn: () => findLabelByValue(projectId, value),
        enabled: !!projectId && !!value?.trim(),
    });
};


export const useTestCaseLabels = (testCaseId) => {
    return useQuery({
        queryKey: [labelKeys.testCaseLabels, testCaseId],
        queryFn: () => getLabelsForTestCase(testCaseId),
        enabled: !!testCaseId,
    });
};

export const useAssignLabelToTestCase = (testCaseId, { onSuccess, onError } = {}) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (labelId) => assignLabelToTestCase(testCaseId, labelId),
        onSuccess: (data) => {
            queryClient.invalidateQueries([labelKeys.testCaseLabels, testCaseId]);
            onSuccess?.(data);
        },
        onError: (error) => onError?.(error),
    });
};

export const useUnassignLabelFromTestCase = (testCaseId, { onSuccess, onError } = {}) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (labelId) => removeLabelFromTestCase(testCaseId, labelId),
        onSuccess: () => {
            queryClient.invalidateQueries([labelKeys.testCaseLabels, testCaseId]);
            onSuccess?.();
        },
        onError: (error) => onError?.(error),
    });
};
